import { createSlice } from '@reduxjs/toolkit'

import { AppReducerState } from '../types'

import appReducers from './appReducers'

const appInitialState: AppReducerState = {
  isErrorModalVisible: false,
  errorModalConfig: null,

  isCartDrawerVisible: false,
  isMobileDrawerVisible: false,
  isSwitchLanguageModalVisible: false,
  orderDrawerOrderId: null,

  isSignalROnline: false,
}

const appSlice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: appReducers,
})

export const {
  appSetIsErrorModalVisible,
  appShowError,
  appSetIsCartDrawerVisible,
  appSetOrderDrawerOrderId,
  appSetIsMobileDrawerVisible,
  appSetIsSwitchLanguageModalVisible,
  appSetIsSignalROnline,
} = appSlice.actions

export default appSlice.reducer
